import { connectEditor } from './connect-editor';
import QuoteLineTable from './QuoteLineTable';

export default connectEditor(state => ({ quoteLines: state.quote.quoteLines }))(
  QuoteLineTable,
);
